export const emailValidationRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
